import React from 'react';
import { IGroupMember } from '../../../store/group/groupState';
import MemberImage from '../memberimage/MemberImage'

interface IOwnProps {
    member: IGroupMember;
    modifierClass?: string;
    useRoundedImage?: boolean;
    useRoleTitle?: boolean;
    hideContactInfo?: boolean;
}

type Props = IOwnProps;

const responsibleRoleMap: { [key: string]: string } = {
    'Responsible': 'Praktisk ansvarlig',
    'Coordinator': 'Faglig ansvarlig'
};

class Contact extends React.Component<Props, {}> {
    public render() {
        return <div className={'contact'.cAppend(this.props.modifierClass)}>
            <MemberImage member={this.props.member} useRoundedImage={this.props.useRoundedImage} />
            <div className="contact__body">
                <h2 className="contact__headline">{this.props.member.fullName}</h2>
                {this.renderBusinessCard()}
            </div>
        </div>;
    }

    private renderBusinessCard() {
        if (!this.props.member.businessCard) {
            return null;
        }

        return <React.Fragment>
            <h3 className="contact__sub-headline" key="1">{this.renderTitle()}</h3>
            {!this.props.hideContactInfo &&
                <ul className="contact__contact-info" key="2">
                    {this.props.member.businessCard.mobile && this.renderContactInfo('Mobil', this.url(`tel:${(this.phoneNumber(this.props.member.businessCard.mobile) as string).replace(/ /g, '')}`, this.phoneNumber(this.props.member.businessCard.mobile) as string, false))}
                    {this.props.member.businessCard.phone && this.renderContactInfo('Direkte', this.url(`tel:${(this.phoneNumber(this.props.member.businessCard.phone) as string).replace(/ /g, '')}`, this.phoneNumber(this.props.member.businessCard.phone) as string, false))}
                    {this.props.member.businessCard.email && this.props.member.businessCard.email !== 'hidden'  && this.renderContactInfo('E-mail', this.url(`mailto:${this.props.member.businessCard.email}`, this.props.member.businessCard.email, false))}
                    {this.renderContactInfo('LinkedIn', this.url(this.props.member.linkedInUrl, 'LinkedIn profil'))}
                </ul>
            }
        </React.Fragment>;
    }

    private renderTitle() {
        if (this.props.useRoleTitle) {
            return <div>
                {responsibleRoleMap[this.props.member.role]}
                {this.props.member.businessCard!.title ? <>,<br />{this.props.member.businessCard!.title}</> : null}
             </div>;
        } else {
            return <div>
                {''.cAppend(this.props.member.businessCard!.title, this.props.member.businessCard!.title)}
                {this.props.member.businessCard!.title && this.props.member.businessCard!.companyName ? <>,<br /></> : null}
                {''.cAppend(this.props.member.businessCard!.companyName, this.props.member.businessCard!.companyName)}
            </div>;
        }
    }

    private renderContactInfo(contactInfo: string, value: any) {
        if (!value) {
            return null;
        }

        return <li>
            <span className="contact__contact-info__label">{contactInfo}:</span>
            <span className="contact__contact-info__value">{value}</span>
        </li>;
    }

    private url(url: string, linkText: string, newWindow: boolean = true) {
        if (!url) {
            return null;
        }

        return <a href={`${url}`} target={newWindow ? '_blank' : undefined} rel={newWindow ? 'noopener' : undefined}>{linkText}</a>;
    }

    private phoneNumber(phoneNumber: string) {
        if (!phoneNumber) {
            return null;
        }

        const twoDigitCountryCodeRegex = /^\+?([0-9]{2})? ?([0-9]{4})? ?([0-9]{4})$/;
        const match = phoneNumber.match(twoDigitCountryCodeRegex);

        if (!match) {
            return phoneNumber;
        }

        return `+${match[1] || '45'} ${match[2] || '3377'} ${match[3]}`;
    }
}

export default Contact;